/**
 * Setup Module Routes Configuration
 *
 * Routes for the setup module
 * Path: /app/maud-erp/{module}/setup/*
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy load components
const SetupPage = lazy(() => import('../index'));
const CourtTypePage = lazy(() => import('../court-type'));

// LAMS Masters
const DocumentTypeManagement = lazy(() => import('../../../business/maud-erp/leases-and-agreements/masters/document-type'));
const RentIncrementTypeManagement = lazy(() => import('../../../business/maud-erp/leases-and-agreements/masters/rent-increment-type'));
const ReservationCategoryManagement = lazy(() => import('../../../business/maud-erp/leases-and-agreements/masters/reservation-category'));
const AssetCategoryManagement = lazy(() => import('../../../business/maud-erp/leases-and-agreements/masters/asset-category'));
// §4.4.3 lease-type taxonomy — master data, so it belongs beside the other LAMS
// masters here rather than as a top-level module screen.
const AgreementTypeManagement = lazy(() => import('../../../business/maud-erp/leases-and-agreements/masters/agreement-type'));
const AgreementTemplateManagement = lazy(() => import('../../../business/maud-erp/leases-and-agreements/masters/agreement-template'));

/**
 * Setup routes configuration
 * These routes are mounted under /app/maud-erp/{module}/setup
 */
export const setupRoutes: RouteObject[] = [
  {
    index: true,
    element: <SetupPage />
  },
  {
    path: 'court-type',
    element: <CourtTypePage />
  },
  // LAMS Masters
  {
    path: 'document-type',
    element: <DocumentTypeManagement />
  },
  {
    path: 'rent-increment-type',
    element: <RentIncrementTypeManagement />
  },
  {
    path: 'reservation-category',
    element: <ReservationCategoryManagement />
  },
  {
    path: 'asset-category',
    element: <AssetCategoryManagement />
  },
  {
    path: 'agreement-type',
    element: <AgreementTypeManagement />
  },
  {
    path: 'agreement-template',
    element: <AgreementTemplateManagement />
  }
];

export default setupRoutes;
